import React, { useEffect, useMemo, useState } from "react";
import http from "../../api/http";
import { useBrand } from "../../context/brand-context";
import "./productsFilter.css";

/**
 * Panneau latÃ©ral de filtres
 * - stock: 'all' | 'in' | 'out'
 * - marque: string (insensible Ã  la casse cÃ´tÃ© parent)
 */
export default function ProductsFilter({
  stock = "all",
  onChangeStock,
  selectedBrands = [],
  onToggleBrand,
  onClear,
  brandCounts = {},
}) {
  const { brand } = useBrand();
  const isAmen = brand === "amen";
 const palette = isAmen
    ? { accent: "#7a0f18", bg: "#7a0f18" } // amen
    : { accent: "#2563eb", bg: "#2461eb" }; 
 const dbName = isAmen ? "Amen" : "Amen_C";
  const [marques, setMarques] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false); // repli des filtres en mobile
console.log("data base",dbName)
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
         const { data } = await http.get("/api/marques", {
          headers: { "x-db": dbName },
        });
        const list = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : [];
        const names = list
          .map((m) => (typeof m === "string" ? m : m?.Marque || m?.name || ""))
          .filter(Boolean);
        const uniq = [...new Set(names.map((s) => String(s).trim()))].sort((a, b) =>
          a.localeCompare(b, "fr", { sensitivity: "base" })
        );
        if (alive) setMarques(uniq);
      } catch {
        if (alive) setMarques([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [dbName, brand]);

  const norm = (s) => String(s || "").toLowerCase().trim();
  const filteredBrands = useMemo(() => {
    if (!q) return marques;
    const k = norm(q);
    return marques.filter((m) => norm(m).includes(k));
  }, [marques, q]);

  return (
    <aside
      className="pf-panel"
      style={{ "--pf-accent": palette.accent, "--pf-bg": palette.bg }}
    >
      <header className="pf-head">
        <button
          type="button"
          className="pf-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-label="Afficher ou masquer les filtres"
        >
          <span className="pf-titleWrap">
            <span className="pf-icon" aria-hidden>⚙️</span>
            <span className="pf-title">Filtres</span>
          </span>
          <span className="pf-chevron" aria-hidden>{open ? "▲" : "▼"}</span>
        </button>
        <button type="button" className="pf-reset" onClick={onClear}>
          Réinitialiser
        </button>
      </header>

      <div className={"pf-body" + (open ? " is-open" : "")}>
      {/* MARQUE */}
      <section className="pf-block">
        <div className="pf-blockHeader">
          <h4 className="pf-blockTitle">Marque</h4>
        </div>

        <div className="pf-search">
          <input
            placeholder="Rechercher une marque…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Rechercher une marque"
          />
        </div>

        <div className="pf-list">
          {loading ? (
            <div className="pf-muted">Chargement…</div>
          ) : filteredBrands.length === 0 ? (
            <div className="pf-muted">Aucune marque</div>
          ) : (
            filteredBrands.map((name) => {
              const checked = selectedBrands.includes(name);
              const count = brandCounts?.[name] ?? null;
              return (
                <label key={name} className="pf-item">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggleBrand?.(name)}
                  />
                  <span className="pf-check" aria-hidden />
                  <span className="pf-itemLabel">
                    {name}
                    {typeof count === "number" ? (
                      <em className="pf-badge">({count})</em>
                    ) : null}
                  </span>
                </label>
              );
            })
          )}
        </div>
      </section>

      {/* STOCK */}
      <section className="pf-block">
        <h4 className="pf-blockTitle">Disponibilité</h4>

        <label className="pf-item pf-radio">
          <input
            type="radio"
            name="pf-stock"
            value="in"
            checked={stock === "in"}
            onChange={(e) => onChangeStock?.(e.target.value)}
          />
          <span className="pf-radioMark" />
          <span className="pf-itemLabel">En stock</span>
        </label>

        {/* Option "Rupture de stock" masquée
        <label className="pf-item pf-radio">
          <input
            type="radio"
            name="pf-stock"
            value="out"
            checked={stock === "out"}
            onChange={(e) => onChangeStock?.(e.target.value)}
          />
          <span className="pf-radioMark" />
          <span className="pf-itemLabel">Rupture de stock</span>
        </label>
        */}

        <label className="pf-item pf-radio">
          <input
            type="radio"
            name="pf-stock"
            value="all"
            checked={stock === "all"}
            onChange={(e) => onChangeStock?.(e.target.value)}
          />
          <span className="pf-radioMark" />
          <span className="pf-itemLabel">Tous</span>
        </label>
      </section>
      </div>
    </aside>
  );
}